import { useUserStore } from "~/stores/user";

const whitelist = ["/", "/buy-ticket", "/setup-profile"];
const either = ["/photos"];

export default defineNuxtRouteMiddleware(async (to, from) => {
  const tokenCookie = useCookie("player-portal-token");
  const user = useUserStore();

  if (to.path === "/home") {
    const firstQuery = (v: unknown): string | null => {
      const value = Array.isArray(v) ? v[0] : v;
      return typeof value === "string" && value.length > 0 ? value : null;
    };
    const key = firstQuery(to.query.key);
    const source = firstQuery(to.query.source);
    const scannerCode = firstQuery(to.query.scannerCode);
    const id = Number(firstQuery(to.query.id));
    if (key && Number.isFinite(id) && id > 0) {
      try {
        await user.loginWithKey(key, id);
      } catch {
        user.clearKeyLoginContext();
        return navigateTo("/");
      }
      user.setKeyLoginContext({ source, key, id, scannerCode });
      return navigateTo("/home", { replace: true });
    }
  }

  const isWhitelisted = whitelist.some(
    (path) => to.path === path || to.path.startsWith(path + "/")
  );

  if (tokenCookie.value && !user.playerId) {
    try {
      await user.getUserInfo({ throwOnError: true });
    } catch {
      tokenCookie.value = "";
    }
  }

  if (!isWhitelisted && !either.includes(to.path) && !tokenCookie.value) {
    return navigateTo("/");
  }
});
